
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import addPhoto from '../../assets/image/addphoto.svg';
import Loader from '../../Components/Loader/Loader';

function AddCoach() {

    const [teacherName, setTeacherName] = useState('')
    const [popaName, setPOPaName] = useState('')
    const [teacherEmail, setTeacherEmail] = useState('')
    const [number, setNumber] = useState('')
    const [teacherid, setTeacherid] = useState('')
    const [page, setPage] = useState(1)
    const [regionList, setRegionList] = useState([]);
    const [regionId, setRegionId] = useState("");
    const [countryList, setCountryList] = useState([]);

    const [schoolList, setSchoolList] = useState([])
    const [countryId, setCountryId] = useState("");
    const [stateList, setStateList] = useState([]);
    const [stateId, setStateId] = useState("");
    const [districtList, setDistrictList] = useState([]);
    const [districtId, setDistrictId] = useState("");
    const [blockList, setBlockList] = useState([]);
    const [blockId, setBlockId] = useState("");
    const location = useLocation()
    const [gender, setGender] = useState("")
    const [emailErr, setEmailErr] = useState("")
    const [gradeList, setGradeList] = useState([])

    const [countryCode, setCountryCode] = useState("");
    const navigate = useNavigate();
    const [updateSchool, setUpdateSchool] = useState(false)
    console.log(location, "See teh Location daraaaa")
    const goBack = () => {
        navigate(-1); // Navigates back to the previous page
    };
    const [image, setImage] = useState(null);
    const [file, setFile] = useState()

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
        setFile(file)
    };
    const addTeacher = async (e) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Validate required fields
        if (!teacherName) return toast.error("Coach name is required");
        if (!teacherEmail) return toast.error("Email is required");
        //    if (!number) return toast.error("Phone number is required");
        if (!emailPattern.test(teacherEmail)) return toast.error("Invalid email format");
        if (countryCode && !number) return toast.error("Mobile number is required when country code is provided");
        if (number && !countryCode) return toast.error("Country code is required when mobile number is provided");

        if (!gender) return toast.error("Gender is required");
        if (!popaName) return toast.error("PO/PA is required");
        if (!regionId) return toast.error("Region is required");
        if (!stateId) return toast.error("State is required");
        if (!districtId) return toast.error("District is required");
        if (!blockId) return toast.error("Block is required");
       

      
        setLoading(true)
        const data = new FormData();
        data.append("name", teacherName);
        data.append("email", teacherEmail);
        data.append("phone", number);
        data.append("gender", gender);
        data.append("region_id", regionId);
        data.append("state_id", stateId);
        data.append("district_id", districtId);
        data.append("block_id", blockId);
        if (file) {
            data.append("image", file);
        }
        data.append("country_id", countryId);
        data.append("country_code", countryCode);
        data.append("po_pa", popaName);
      
        try {
            const response = await handleApiCall("post", endpoint.addcoach, data);
            console.log(response, "Add Teacher");
            if (response?.data?.code === 200) {
                setLoading(false)
                toast.success(response?.data?.message);
               
                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            } else {
                setLoading(false)
                toast.error(response?.response?.data?.errorMessage || "Failed to add coach");
            }
        } catch (error) {
            setLoading(false)
            console.error("Error adding teacher:", error);
            toast.error("Something went wrong!");
        }
    };
    const UpdateTeacher = async (e) => {
       
        console.log("djjdjdjdj------------", location.state)
        // Validate required fields
        if (!teacherName) return toast.error("Coach name is required");
        if (!teacherEmail) return toast.error("Email is required");
        //    if (!number) return toast.error("Phone number is required");
        if (countryCode && !number) return toast.error("Mobile number is required when country code is provided");
        if (number && !countryCode) return toast.error("Country code is required when mobile number is provided");

        if (!gender) return toast.error("Gender is required");
        if (!popaName) return toast.error("PO/PA is required");
        if (!regionId) return toast.error("Region is required");
        if (!stateId) return toast.error("State is required");
        if (!districtId) return toast.error("District is required");
        if (!blockId) return toast.error("Block is required");
       
      

      

        // if (!file) return toast.error("Profile image is required");


        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(teacherEmail)) return toast.error("Invalid email format");

        // Phone number validation (10-digit check for example)
        //    const phonePattern = /^[0-9]{10}$/;
        //    if (!phonePattern.test(number)) return toast.error("Invalid phone number (10 digits required)");
        setLoading(true)
        const data = new FormData();
        data.append("name", teacherName);
        data.append("email", teacherEmail);
        data.append("phone", number);
        data.append("gender", gender);
        data.append("region_id", regionId);
        data.append("state_id", stateId);
        data.append("district_id", districtId);
        data.append("block_id", blockId);
        file && data.append("image", file);
        data.append("country_id", countryId);
        data.append("country_code", countryCode);
        data.append("po_pa", popaName);
        data.append("id", location?.state?._id);


        try {
            const response = await handleApiCall("put", endpoint.editCoach, data);
            console.log(response, "Add coach");
            if (response?.data?.code === 200) {
                toast.success(response?.data?.message);
                setLoading(false)
                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            } else {
                setLoading(false)
                toast.error(response?.response?.data?.errorMessage || "Failed to add teacher");
            }
        } catch (error) {
            setLoading(false)
            console.error("Error adding teacher:", error);
            toast.error("Something went wrong!");
        }
    };

    useEffect(() => { getRegionList(); }, []);
    useEffect(() => { getCountryList(); }, [regionId]);
    useEffect(() => { getStateList(); }, [countryId]);
    useEffect(() => { getDistrictList(); }, [stateId]);
    useEffect(() => { getBlockList(); }, [districtId]);
    useEffect(() => { getSchoolList(); }, [districtId]);
    useEffect(() => { getGreadList(); }, []);
    const getGreadList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.gradeList}`, {});
            if (response?.data?.code === 200) setGradeList(response?.data?.data?.gradeList);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };
    const getRegionList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.regionList}`, {});
            if (response?.data?.code === 200) setRegionList(response.data.data);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };

    const getCountryList = async () => {
        if (!regionId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.countryList}?region_id=${regionId}`, {});
            if (response?.data?.code === 200) setCountryList(response.data.data);
        } catch (e) { console.log("Error fetching country list:", e); }
    };

    const getStateList = async () => {
        if (!countryId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.stateList}?country_id=${countryId}`, {});
            if (response?.data?.code === 200) setStateList(response.data.data);
        } catch (e) { console.log("Error fetching state list:", e); }
    };

    const getDistrictList = async () => {
        if (!stateId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.district}?state_id=${stateId}`, {});
            if (response?.data?.code === 200) setDistrictList(response.data.data);
        } catch (e) { console.log("Error fetching district list:", e); }
    };

    const getBlockList = async () => {
        if (!districtId) return;
        try {
            const response = await handleApiCall("get", `${endpoint.blocklist}?district_id=${districtId}`, {});
            if (response?.data?.code === 200) setBlockList(response.data.data);
        } catch (e) { console.log("Error fetching block list:", e); }
    };

    const getSchoolList = async () => {

        try {
            const response = await handleApiCall("get", `${endpoint.schoolList}?page=${page}?limit${20}`, {});
            if (response?.data?.code === 200) setSchoolList(response?.data?.data?.schoolList);
        } catch (e) { console.log("Error fetching district list:", e); }
    };

    // Reset dependent fields when parent field changes
    const handleRegionChange = (value) => {
        setRegionId(value);
        setCountryId("");
        setStateId("");
        setDistrictId("");
        setBlockId("");
        setCountryList([])
        setStateList([])
        setDistrictList([])
        setBlockList([])
    };

    const handleCountryChange = (value) => {
        setCountryId(value);
        setStateId("");
        setDistrictId("");
        setBlockId("");
        setStateList([])
        setDistrictList([])
        setBlockList([])
    };

    const handleStateChange = (value) => {
        setStateId(value);
        setDistrictId("");
        setBlockId("");
        setDistrictList([])
        setBlockList([])
    };

    const handleDistrictChange = (value) => {
        setDistrictId(value);
        setBlockId("");
        setBlockList([])
    };

    const urlToFile = async (url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const fileName = url.split("/").pop();
            return new File([blob], fileName, { type: blob.type });
        } catch (error) {
            console.error("Error fetching image:", error);
        }
    };

    const convertAndSetFile = async () => {
        console.log("Location State:", location?.state); // Debugging
        console.log("Image URL:", location?.state?.image); // Debugging

        if (!location?.state?.image) {
            console.error("Image URL is undefined or missing.");
            return;
        }

        try {
            const file = await urlToFile(location.state.image);
            setFile(file); // Store file in state
            console.log("File stored:", file); // Debugging
        } catch (error) {
            console.error("Error converting URL to file:", error);
        }
    };

    const editData = () => {
        if (location?.state) {
            console.log(location.state, "Dataa==>>")
            setUpdateSchool(true)
            setRegionId(location?.state?.region_id)
            setCountryId(location?.state?.country_id)
            setDistrictId(location.state?.district_id)
            setBlockId(location?.state?.block_id)
            setStateId(location?.state?.state_id)
            setTeacherName(location?.state?.full_name)
            setTeacherEmail(location?.state?.email)
            setNumber(location?.state?.phone)
            setCountryCode(location?.state?.country_code)
            setGender(location?.state?.gender)
            setImage(location?.state?.image)
            setPOPaName(location?.state?.po_pa)
            convertAndSetFile()


        }
        else {
            setRegionId("");
            setCountryId("");
            setStateId("");
            setDistrictId("");
            setBlockId("");
            setTeacherName("");
            setTeacherEmail("");
            setNumber("");
            setTeacherid("");
            setGender("");
            setCountryCode("");
        }
    }

    useEffect(() => {
        editData()
    }, [])


    const[loading,setLoading]=useState(false)
    return (
        <>
            <Toastify />
            <Loader isLoading={loading} /> {/* Call Loader */}


            <div className="common-table-wrapper m-0 ">
                <div className="flex items-start gap-4">
                    {/* Hidden File Input */}
                    <input
                        type="file"
                        id="fileInput"
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageChange}
                    />

                    {/* Label acts as a button */}
                    <label
                        htmlFor="fileInput"
                        className="flex items-center justify-center w-24 h-24 rounded-full border border-black cursor-pointer"
                    >
                        {image ? (
                            <img
                                src={image}
                                alt="Selected"
                                className="w-full h-full rounded-full object-cover"
                            />
                        ) : (
                            <img
                            src={addPhoto}
                            className=" object-cover p-2"></img>
                        )}
                    </label>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2 py-3">
                    <input
                        type="text"
                        placeholder="Coach Name"
                        required
                        maxLength={150}
                        value={teacherName}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Prevent leading spaces
                            value = value.replace(/^[^a-zA-Z0-9]+/, "");

                            setTeacherName(value);
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />

                    <div>
                        <input
                            type="email"
                            placeholder="Email"
                            required
                            value={teacherEmail}
                            onKeyPress={(e) => {
                                // Prevent space key from being typed
                                if (e.key === " " || e.code === "Space") {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                let value = e.target.value.replace(/\s/g, ''); // Remove spaces
                                setTeacherEmail(value); // Set the value without spaces

                                // Email format validation
                                if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                                    setEmailErr("Please enter a valid email.");
                                } else {
                                    setEmailErr('');
                                }
                            }}
                            className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                        />
                        {emailErr && <p className="text-red-500 text-xs ">{emailErr}</p>}
                    </div>
                    <input
                        type="text"
                        placeholder="Country Code (Optional)"
                        required

                        maxLength={5}
                        value={countryCode} onChange={(e) => {
                            const value = e.target.value.replace(/\s/g, ''); // Remove spaces
                            if (/^[+0-9,]*$/.test(value)) { // Only allow numbers, plus, and commas
                                setCountryCode(value);
                            }
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                    <input
                        type="text"
                        placeholder="Phone Number (Optional)"

                        maxLength={17}
                        value={number} onChange={(e) => {
                            const value = e.target.value.replace(/\s/g, ''); // Remove spaces
                            if (/^[0-9]*$/.test(value)) { // Only allow digits
                                setNumber(value);
                            }
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />

                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2 pb-3 ">



                    <select
                        onChange={(e) => setGender(e.target.value)}
                        required
                        className="p-2 bg-[#F6F6F6]  font-bold border-[1px] border-black  rounded-md focus:outline-none w-full h-full"
                        value={gender} // Bind value to state
                    >
                        <option value="" disabled>
                            Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <input
                        type="text"
                        placeholder="PO/PA Name"
                        required
                        max={150}
                        value={popaName}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Prevent leading spaces
                            value = value.replace(/^[^a-zA-Z0-9]+/, "");

                            setPOPaName(value);
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black  rounded-md focus:outline-none w-full h-full"
                    />
                </div>




                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 px-2 py-1 min-h-[100px]">
                    <select
                        required
                        value={regionId}
                        onChange={(e) => handleRegionChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose Region
                        </option>
                        {regionList.length > 0 ? (
                            regionList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No Region Available
                            </option>
                        )}
                    </select>

                    <select
                        required
                        value={countryId}
                        onChange={(e) => handleCountryChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose Country
                        </option>
                        {countryList.length > 0 ? (
                            countryList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No Country Available
                            </option>
                        )}
                    </select>

                    <select
                        required
                        value={stateId}
                        onChange={(e) => handleStateChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose State
                        </option>
                        {stateList.length > 0 ? (
                            stateList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No State Available
                            </option>
                        )}
                    </select>

                    <select
                        required
                        value={districtId}
                        onChange={(e) => handleDistrictChange(e.target.value)}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose District
                        </option>
                        {districtList.length > 0 ? (
                            districtList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No District Available
                            </option>
                        )}
                    </select>
                    <select
                        required
                        value={blockId}
                        onChange={(e) => {
                            setBlockId(e.target.value);


                        }}
                        className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    >
                        <option value="" disabled selected>
                            Choose Block
                        </option>
                        {blockList.length > 0 ? (
                            blockList.map(item => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))
                        ) : (
                            <option value="" disabled>
                                No Block Available
                            </option>
                        )}
                    </select>


                </div>




                <div className=' flex gap-3 mx-2 mt-10'>
                    <div

                        onClick={() => navigate("/coach-management")}

                        className="  text-black  font-bold inline-flex cursor-pointer justify-center px-4 ms-2 items-center hover:bg-[#F6F6F6] border-black rounded-md border-[2px] py-2"
                    >
                        Cancel
                    </div>
                    <button onClick={() => { updateSchool ? UpdateTeacher() : addTeacher() }}
                        className="text-white bg-[#994263] px-5 font-bold inline-flex cursor-pointer justify-center ms-2 items-center py-2 hover:bg-[#e6e0e2] hover:text-black border-[#994263] rounded-md border-[2px]"
                    >
                        {updateSchool ? "Update" : "Add"}
                    </button>

                </div>




            </div>

        </>
    )
}

export default AddCoach
